import { Subject } from 'rxjs/Subject';
import { ItemsResponse } from './../model/itemsresponse';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonConstants } from '../../../../common/constants/common-constants';
import { ItemCategoriesResultEntity } from '../../shared/model/itemcategoriesresponse';
import { ItemTypesResultEntity } from '../../shared/model/itemtypesresponse';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';



@Injectable()
export class ItemsService {

    private _itemResultsCount = new Subject<number>();

    constructor(public http: HttpClient) {
    }

    // function call to fetch item list
    public getItemsList(params: HttpParams): Observable<ItemsResponse> {
        let data = this.http.get<ItemsResponse>(CommonConstants.SERVICE_VERSION_PATH_V1 +
            '/customer/ci/items', { params })
            .pipe(tap(resp => {
                this._itemResultsCount.next(resp.resultCount);
            }
            ));
        return data;
    }


    public getItemCategories() {
        const params = new HttpParams()
            .set('itemOption', 'ITEM');
        return this.http.get<ItemCategoriesResultEntity[]>(CommonConstants.SERVICE_VERSION_PATH_V1 +
            '/customer/allCategories', { params });
    }

    public getItemTypes() {
        const params = new HttpParams()
            .set('itemOption', 'ITEM');
        return this.http.get<ItemTypesResultEntity[]>(CommonConstants.SERVICE_VERSION_PATH_V1 +
            '/customer/allItemTypes', { params });
    }

    public getItemResultsCount(): Observable<number> {
        return this._itemResultsCount;
    }
}
